// Navbar.jsx

import React, { useState } from "react";
import { Menu, Icon, Input, Button, Image, Grid } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "../styles/UserNavbar.css";

const RequestNavbar = ({
  setToggle,
  navTitle,
  type,
  showUsersCount,
  showDatasetCount,
  NavbarCollapse,
  handleApproveAllDatasetRequest,
  handleDenyAllDatasetRequest,
}) => {
  const { userIdParam, userNameParam } = useParams();
  const navBarTitle =
    type === "user_dataset_requests" ? userNameParam : navTitle || "Q&A";
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value.toLowerCase());
    // onDataFromChild(event.target.value.toLowerCase());
  };
  const navigate = useNavigate();

 
  const handleBackRequest = async () => {
    sessionStorage.removeItem("filterIds");
    navigate(`/adminconsole/requests`);
  };


  return (
    <Menu fixed="top" className="navbar" borderless style={{ zIndex: "0" }}>
      <Menu.Menu className={`${!NavbarCollapse ? "" : "navbar-collapse"}`}>
        {/* Mobile View  and desktop view*/}
        {!NavbarCollapse ? (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                {type === "dataset_request" && (
                  <>
                    <Image src="/images/requests.svg" alt="Data Console" />
                  </>
                )}
                <label>{navBarTitle || "Default"}</label>
              </Menu.Item>
            </React.Fragment>
            {type === "dataset_request" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showUsersCount || 0} Users</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchMobile"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder=" "
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchMobile">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
          </Grid>
        ) : (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left-request">
                {type === "dataset_request" && (
                  <>
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                    <Image src="/images/requests.svg" alt="Data Console" />
                  </>
                )}
                {type === "user_dataset_requests" && (
                  <>
                    <Image
                      className="backButton"
                       onClick={handleBackRequest}
                      src="/images/Back.svg"
                      alt="Back Button"
                    />
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                    <Image src="/images/requests.svg" alt="Data Console" />
                  </>
                )}
                <label>
                  {navBarTitle.length < 25
                    ? navBarTitle
                    : navBarTitle.slice(0, 24) + "..." || "Default"}
                </label>
              </Menu.Item>
            </React.Fragment>
            {/*Desktop landing Page */}
            {type === "dataset_request" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showUsersCount || 0} Users</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchDesktop"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder=""
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchDesktop">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}

            {type === "user_dataset_requests" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showDatasetCount || 0} Datasets</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchDesktop"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder=""
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchDesktop">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
          </Grid>
        )}
      </Menu.Menu>

      {/* Right-aligned content */}
      <Menu.Menu position="right">
        <React.Fragment>
          {type === "user_dataset_requests" && (
            <Menu.Item className="hide-add-dataset-button-desktop approve-button-set">
              <Button
                primary
                onClick={handleApproveAllDatasetRequest}
                className="button-data-console"
                data-cy="add-dataset-btn-link"
              >
                <div className="button-data-console-parent">
                  Approve all
                </div>
              </Button>
              <Button
                error
                onClick={handleDenyAllDatasetRequest}
                className="button-data-console deny-all-button"
                data-cy="add-dataset-btn-link"
              >
                <div className="button-data-console-parent">
                  Deny all
                </div>
              </Button>
            </Menu.Item>
          )}
          {/* <Menu.Item position="right">
            <img
              src="/images/filter.svg" // Using the imported delete image
              alt="Vie More"
              // onClick={() => handleDelete(row.id)}
              style={{ cursor: "pointer" }}
            />
          </Menu.Item> */}
        </React.Fragment>
      </Menu.Menu>
    </Menu>
  );
};

export default RequestNavbar;
